import { CcV4Button } from "../../cc-v4/CcV4Button";

/** @deprecated Используйте CcV4Button variant="outline" */
export const BtnOutlineV4 = ({
  onClick,
  text,
  className,
  type = "button",
  children,
  ...rest
}) => (
  <CcV4Button
    variant="outline"
    onClick={onClick}
    text={text}
    className={className}
    type={type}
    {...rest}
  >
    {children}
  </CcV4Button>
);
